import React, { useState } from 'react';

import ButtonLink from '@/components/common/ButtonLink/ButtonLink';
import AgModalWindow from '@/components/common/ModalWindow/AgModalWindow';
import ToggleOptionTitle from '@/components/common/ToggleOption/ToggleOptionTitle';
import styles from './custom-toggle-title.module.scss';

interface ICustomToggleTitleComponentProps {
  title: string;
  displaySettings: Contract['displaySettings'] | undefined;
}

export default function CustomToggleTitleComponent({
  title,
  displaySettings
}: ICustomToggleTitleComponentProps) {
  const [isOpenModalWindow, setIsOpenModalWindow] = useState<boolean>(false);
  const showModalButton = displaySettings && displaySettings.message && displaySettings.hide;

  return (
    <div className="ag-hide-lines">
      <ToggleOptionTitle>
        {title}
      </ToggleOptionTitle>

      {showModalButton && (
        <>
          <div>
            <ButtonLink
              onClick={() => setIsOpenModalWindow(true)}
            >
              <div className={styles['button-title']}>
                Show default commentary
              </div>
            </ButtonLink>
          </div>

          <AgModalWindow
            title="Hide Contract Lines"
            isOpen={isOpenModalWindow}
            onClose={() => setIsOpenModalWindow(false)}
            contentStyle={{ width: 450 }}
          >
            <div style={{ whiteSpace: 'pre-wrap' }}>
              {displaySettings?.message}
            </div>
          </AgModalWindow>
        </>
      )}
    </div>
  );
}
